<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<v-row no-gutters justify="end">
				<v-btn color="secondary" class="ml-2" :disabled="!valid" @click="submitForm">
					<v-icon class="mr-1">mdi-content-save-outline</v-icon>
					保存
				</v-btn>
			</v-row>

			<v-sheet elevation="0">
				<ValidationError :errors="errors" />
				<v-form ref="form" v-model="valid">
					<ProblemCaseForm
						:problem_case.sync="problem_case"
						:existing_files="existingFiles"
						:file_data.sync="file_data"
						:categories="categories"
						:products="products"
						:case_types="case_types"
						:deleted_files.sync="deletedFiles"
					/>
				</v-form>
			</v-sheet>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import CommonFlame from "../shared/CommonFlame.vue"
import ProblemCaseForm from "./components/ProblemCaseForm.vue"
import ValidationError from "../shared/ValidationError.vue"

export default {
	components: {
		CommonFlame,
		ProblemCaseForm,
		ValidationError,
	},
	data() {
		return {
			title: "問題事例編集",
			id: this.$route.params.id,
			valid: false,
			problem_case: {
				case_number: null,
				name: null,
				case_type: null,
				product_category_id: null,
				product_sub_category_id: null,
				product_category_id: null,
				product_id: "",
				description: "",
			},
			categories: [],
			products: [],
			case_types: [],
			existingFiles: [],
			file_data: [],
			deletedFiles: [],
			errors: [],
		}
	},

	mounted() {
		this.fetchProblemCase()
	},
	methods: {
		fetchProblemCase() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/problem_cases/${this.id}/edit`
			axios
				.get(url, {
					headers,
				})
				.then((response) => {
					this.problem_case = response.data.problem_case
					if (response.data.problem_case.product) {
						this.products = [response.data.problem_case.product]
					}
					this.categories = response.data.categories
					this.case_types = response.data.case_types
					this.existingFiles = response.data.existing_files
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		submitForm() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/problem_cases/${this.id}`
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()

			if (this.file_data.length > 0) {
				this.file_data.forEach((file) => {
					formData.append("files[]", file)
				})
			}

			if (this.deletedFiles.length > 0) {
				this.deletedFiles.forEach((file) => {
					formData.append("deleted_files[]", file.id)
				})
			}

			formData.append("problem_case[case_number]", this.problem_case.case_number)
			formData.append("problem_case[name]", this.problem_case.name)
			formData.append("problem_case[case_type]", this.problem_case.case_type)
			if (this.problem_case.product_category_id != null) {
				formData.append("problem_case[product_category_id]", this.problem_case.product_category_id)
			}
			if (this.problem_case.product_sub_category_id != null) {
				formData.append(
					"problem_case[product_sub_category_id]",
					this.problem_case.product_sub_category_id
				)
			}
			if (this.problem_case.product_id != null) {
				formData.append("problem_case[product_id]", this.problem_case.product_id)
			}
			formData.append("problem_case[description]", this.problem_case.description)

			axios
				.put(url, formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "問題事例を編集しました",
					})
					this.$router.push({ name: "problem_case_show", params: { id: res.data.id } })
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
}
</script>
